var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconFavourite = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 25s12-8.516 12-18.194A5.809 5.809 0 0 0 19.194 1C15.988 1 13 3.601 13 6.806 13 3.601 10.012 1 6.806 1A5.809 5.809 0 0 0 1 6.806C1 16.484 13 25 13 25Z",
  fill: "currentColor",
  stroke: "#fff",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

export default SvgIconFavourite;